import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter as Router} from "react-router-dom";

import {Provider} from 'react-redux';
import {createStore,  applyMiddleware} from 'redux';
import thunk from "redux-thunk";
//import logger from "redux-logger";

import restaurantReducer from './reducers/restaurantReducer';

const store = createStore(restaurantReducer, applyMiddleware(thunk));
// add logger to applyMiddleware() to use it

ReactDOM.render(
 <Provider store = {store}>
    <Router>
        <App />
    </Router>
 </Provider>, 
document.getElementById('root'));


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
